import type { IconComponent } from '@alltrails/denali/components/Icon';
import CollBeaches from '@alltrails/denali/icons/CollBeaches';
import CollBuggy from '@alltrails/denali/icons/CollBuggy';
import CollCaves from '@alltrails/denali/icons/CollCaves';
import CollDogFriendly from '@alltrails/denali/icons/CollDogFriendly';
import CollFoliage from '@alltrails/denali/icons/CollFoliage';
import CollHiddenGems from '@alltrails/denali/icons/CollHiddenGems';
import CollHotSprings from '@alltrails/denali/icons/CollHotSprings';
import CollKidFriendly from '@alltrails/denali/icons/CollKidFriendly';
import CollLakes from '@alltrails/denali/icons/CollLakes';
import CollNearby from '@alltrails/denali/icons/CollNearby';
import CollOvergrown from '@alltrails/denali/icons/CollOvergrown';
import CollParks from '@alltrails/denali/icons/CollParks';
import CollRivers from '@alltrails/denali/icons/CollRivers';
import CollRocky from '@alltrails/denali/icons/CollRocky';
import CollScramble from '@alltrails/denali/icons/CollScramble';
import CollTopPicks from '@alltrails/denali/icons/CollTopPicks';
import CollTrailStroller from '@alltrails/denali/icons/CollTrailStroller';
import CollTrailWheelchair from '@alltrails/denali/icons/CollTrailWheelchair';
import CollTrees from '@alltrails/denali/icons/CollTrees';
import CollUv from '@alltrails/denali/icons/CollUv';
import CollViews from '@alltrails/denali/icons/CollViews';
import CollWaterfalls from '@alltrails/denali/icons/CollWaterfalls';
import CollWildflowers from '@alltrails/denali/icons/CollWildflowers';
import CollWildlife from '@alltrails/denali/icons/CollWildlife';
import HistoricSiteFilled from '@alltrails/denali/icons/HistoricSiteFilled';
import type { TrailHighlightType } from '@alltrails/types/TrailHighlight';

const ICONS: Record<TrailHighlightType, IconComponent> = {
  content_guide: CollParks,
  content_curated: CollHiddenGems,
  content_programmatic: CollTopPicks,
  'info_low-cell-service': CollNearby,
  review_waterfalls: CollWaterfalls,
  'review_hot-springs': CollHotSprings,
  review_beaches: CollBeaches,
  review_caves: CollCaves,
  'review_historic-sites': HistoricSiteFilled,
  'review_fall-foliage': CollFoliage,
  review_wildflowers: CollWildflowers,
  'review_rocky-terrain': CollRocky,
  review_scramble: CollScramble,
  'review_overgrown-obstructed': CollOvergrown,
  review_buggy: CollBuggy,
  'review_sun-exposed': CollUv,
  'review_water-crossing': CollRivers,
  'review_dog-friendly': CollDogFriendly,
  'review_kid-friendly': CollKidFriendly,
  'review_stroller-friendly': CollTrailStroller,
  'review_wheelchair-friendly': CollTrailWheelchair,
  review_wildlife: CollWildlife,
  'review_great-views': CollViews,
  review_forests: CollTrees,
  review_lakes: CollLakes,
  review_rivers: CollRivers
};

const getTrailHighlightIcon = (type: TrailHighlightType): IconComponent => ICONS[type];

export default getTrailHighlightIcon;
